import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BillingRole, Track } from 'src/models/employee';

const AppSlice = createSlice({
  name: 'employees-info-state',
  initialState: {
    tracks: [],
    billingRoles: []
  } as { tracks: Track[], billingRoles: BillingRole[] },
  reducers: {
    setBillingRoles: (state, action: PayloadAction<BillingRole[] | undefined>) => {
        state.billingRoles = action.payload;
      },
    setTracks: (state, action: PayloadAction<Track[] | undefined>) => {
        state.tracks = action.payload;
  },
}});

const { reducer, actions } = AppSlice;

export const EmployeesActions = actions;
export const EmployeeReducer = reducer;
